import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {DashboardNs} from "@shared/types";
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {MarketNs} from "@shared/types/marketplace.namespace";
import {useMarketStore} from "@domains/marketplace/stores/marketplace.store";
import {toast} from '@shared/ms-components'

export const importProjectResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {

  const {pr, put} = to.query;
  if (!pr || !put) {
    toast.success('Project link not valid!');
    next({name: DashboardNs.DashboardRouteEnums.PROJECTS})
  } else {
    const workspaceStore = useWorkspaceStore();
    const payload = {
      workspaceId: workspaceStore.getSelectedWorkspaceId,
      projectId: pr,
      token: put
    } as MarketNs.ImportProjectRequest

    const marketStore = useMarketStore();
    marketStore.importProject(payload).finally(() => next({name: DashboardNs.DashboardRouteEnums.PROJECTS}))
  }
};
